import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface TermsAndConditionsApi extends CMSApiBase {
  title: string;
  titleH1: string;
  text: string;
  textOtherDomain: string;
  textAlternative: string;
  effectiveFrom: string;
  lastUpdated: string;
}

export const termsAndConditionsV3 = (lang: string) =>
  request<TermsAndConditionsApi>({
    url: buildCmsUrl({ path: 'term-and-conditions', lang }),
  });

export const termsAndConditionsV4 = (lang: string) =>
  request<TermsAndConditionsApi>({
    url: buildCmsUrl({ path: 'term-and-condition', lang }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<TermsAndConditionsApi>
    ),
  });

export const termsAndConditions = isCMSV3
  ? termsAndConditionsV3
  : termsAndConditionsV4;
